import React, { useState, useEffect } from 'react';
import HelpTogal from '../TogelButton/HelpTogal';
import BrandServices from '../../services/BrandServices';

function BrandUpdate({ brand, closeModal, onSuccess }) {
    const [formValues, setFormValues] = useState({
        name: '',
        type: '',
        image: '',
    });
    const [previewImage, setPreviewImage] = useState('img/placeholder-img.png'); // Placeholder image path

    useEffect(() => {
        if (brand) {
            setFormValues({
                type: brand?.type || '',
                name: brand?.name || '',
                image: brand?.image || '',


            });
            if (brand.image) {
                setPreviewImage(process.env.REACT_APP_URL + brand.image);
            }
        }
    }, [brand]);

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormValues({
            ...formValues,
            [name]: value,
        });
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setPreviewImage(reader.result);
            };
            reader.readAsDataURL(file);
            setFormValues({
                ...formValues,
                image: file,
            });
        }
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        try {
            const formData = new FormData();
            for (const key in formValues) {
                if (key !== 'image' || formValues[key] instanceof File) {
                    formData.append(key, formValues[key]);
                }
            }
    
            if (!brand._id) {
                alert('Brand ID is missing');
                return;
            }
    
            await BrandServices.updateBrand(brand._id, formData); // Use _id if that's the correct field name
            alert('Brand updated successfully');
            onSuccess();
            closeModal();
        } catch (error) {
            console.error('Failed to update brand', error);
            alert('Failed to update brand');
        }
    };
    

    return (
        <div className="modal fade edit-box show d-block" id="editModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Edit Brand </h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" onClick={closeModal} aria-label="Close" />
                    </div>
                    <div className="modal-body">
                        <div className="container-box px-5">
                            <div className="container-box-inner table-reponsive-tabe">
                                <div className="page-details">
                                    <form onSubmit={handleSubmit}>
                                        <div className='row'>
                                            <div className="col-md-6">
                                                <div className="input-field">
                                                    <label>Select your Vehicle Type<span className="red">*</span></label>
                                                    <select className="form-control" value={formValues.type}
                                                        onChange={handleInputChange} name="type">
                                                        <option value="">--Select Type--</option>
                                                        <option value="Car">Car</option>
                                                        <option value="Bike or 3-Wheeler">Bike or 3-Wheeler</option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <div className="input-field">
                                                    <label>Select your Brand<span className="red">*</span></label>
                                                    <input type="text" name="name" value={formValues.name}
                                                        onChange={handleInputChange} placeholder="Brand Name" className="form-control" required />
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <div className="input-field">
                                                    <label>Brand Logo<span className="red">*</span></label>
                                                    <input type="file" name="image" className="form-control" onChange={handleFileChange}  />
                                                    <p><span>Drop an image or Paste URL (up to resolution 1,500 x 1,500 px),</span> Supported formats: png, jpeg, jpg, webp</p>
                                                    <div className="file-preview text-center">
                                                        <img id="uploadFile" src={previewImage} alt="your image" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <button className="submit-green-btn">Submit</button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default BrandUpdate;
